import { DialogTitle, DialogContent, Grid2 } from '@mui/material';
import WrestlerBirthGenderForm from './WrestlerBirthGenderForm';

// const COED_OPTIONS = [
//     { value: 'co-ed', label: 'CO-ED' },
//     { value: 'girls-only', label: 'Girls Only' },
// ];

export default function WrestlerBirthStep() {
    // const { watch } = useFormContext<AddAthleteFormValues>();
    // const [gender] = watch(['gender']);

    return (
        <>
            {/* TODO: extract Grid contents to external component? */}
            <DialogTitle>Birthday / Gender</DialogTitle>
            <DialogContent>
                <Grid2 container spacing={4} padding={4} paddingTop={2} alignItems={'flex-end'}>
                    <WrestlerBirthGenderForm />
                </Grid2>
            </DialogContent>
        </>
    );
}
